import { GET_CONTACT_SUCCESS, HIDE_MESSAGE, ON_HIDE_LOADER, ON_SHOW_LOADER, SHOW_MESSAGE } from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  contact: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    
    case GET_CONTACT_SUCCESS: {
      return {
        ...state,
        loader: false,
        contact: action.payload,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
